import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvService } from './env.service';
import { CallBackTransformService } from './call-back-transform.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(
    private envService: EnvService,
    private http: HttpClient,
    private callBackTransformService: CallBackTransformService
  ) {}

  /**
   * login
   * @param Object loginInfo
   * @return Object Resultset
   */
  login(loginInfo, tenantId): Observable<any> {
    const headers = new HttpHeaders().set('tenantId', tenantId);
    const options = { headers: headers };
    const url = this.envService.apiUrl + 'Login';
    return this.http.post<any>(url, loginInfo, options);
  }

  /**
   * Function to change the password
   * @param Object changePasswordInfo
   * @return Object Resultset
   */
  changePassword(changePasswordInfo): Observable<any> {
    const url = this.envService.apiUrl + 'ResetPassword';
    return this.http.post<any>(url, changePasswordInfo);
  }

  /**
   * Function to get reset passwordToken
   * @param any resetInfo
   * @param any tenantId
   */
  getResetPasswordToken(email, tenantId): Observable<any> {
    const headers = new HttpHeaders().set('tenantId', tenantId);
    const options = { headers: headers };
    const url = this.envService.apiUrl + 'GetResetPasswordToken/' + email;
    return this.http.get<any>(url, options).pipe(
      map((output) => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * Function to modify the password
   * @param any changePasswordInfo
   * @param number tenantId
   */
  forgotPassword(changePasswordInfo, tenantId): Observable<any> {
    const headers = new HttpHeaders().set('tenantId', tenantId);
    const options = { headers: headers };
    const url = this.envService.apiUrl + 'ForgotPassword';
    return this.http.post<any>(url, changePasswordInfo, options);
  }

  /**
   * Function to update the user last login datetime
   */
  updateLastLogin(): Observable<any> {
    const url = this.envService.apiUrl + 'user-last-login';
    return this.http.put<any>(url, {}).pipe(
      map((output) => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  getSSOConfigurations(client): Observable<any> {
    const url = this.envService.apiUrl + 'sso-redirect-url/' + client;
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
}
